import ExcelExportModal, {
    ColumnMapping,
    ActiveFilter,
} from '@/components/ExcelExportModal'
import { ModalProps } from '@/types/shared'

interface ExcelExportModalProps extends ModalProps {
    onExport: (columns: ColumnMapping[], filename: string) => void
    availableColumns: ColumnMapping[]
    feature?: string
    activeFilters?: ActiveFilter[]
}

const ExcelExportModalWrapper = ({
    open,
    onClose,
    onExport,
    availableColumns,
    feature,
    activeFilters,
}: ExcelExportModalProps) => {
    return (
        <ExcelExportModal
            open={open}
            onClose={onClose}
            onExport={onExport}
            availableColumns={availableColumns}
            feature={feature}
            activeFilters={activeFilters}
        />
    )
}

export default ExcelExportModalWrapper
